// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var File = function File(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.612 5.094h-3.596V1.508l3.596 3.586z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.553 5.876H9.191V1.4h-6.8v13.2h11.221V5.939zm-8.767-1h3.091v1.235H4.786zm6.451 7.3H4.786v-1.24h6.45zm0-2.988H4.786V7.949h6.45z"
    }))
  );
};

export default File;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/File.js
// module id = 1008
// module chunks = 0